module.exports = __webpack_public_path__ + "assets/img/e508c019ad79d502e10b2938d5228011.svg";